export const LOADING = 'LOADING_BOOKLIST';
export const ERROR = 'ERROR';

export const BOOKLIST_PERMISSIONS_V1 = 'BOOKLIST_PERMISSIONS_V1';
export const PERMISSIONS = 'PERMISSIONS';

export const PUT_USER_PERMISSIONS = 'PUT_USER_PERMISSIONS';
export const PUT_BOOKLIST_TAGS = 'PUT_BOOKLIST_TAGS';